import store from "@/store/instance";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import {
  showLogic,
  // IQuestion,
  DecorationType,
  ITextTData,
  IAddonData,
  IFillInData,
  IImageData,
  IMultipleChoiceData,
  IPhoneNumberData,
  IQuestionComonentType,
  IQuestionItem,
  // ISelectedoptionsData,
  ISingleChoiceData,
  QuestionFormDataType,
  QuestionType,
  // questionData,
  ICutOffLineData,
  // IFillInMultiItem,
  IFillInRangeData,
  ISingleChoicePickerData,
  IMultipleChoicePickerData,
  IFillInMultiData,
  IDateTimeData,
  IAddressInputData,
  IFillInTableData,
  ISortData,
  IProportionData,
  ICalculatorData,
  IOnlineBooking,
  IDepartment,
} from "../config/newQuestionnaire";
import { saveQuestionnaireDraft, getQuestionnaireDraftByCommtyId, checkItemExist } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { walkArray } from "@/utils/commonUtil";
import { service } from "@modules/newCommunity/setup";
export interface QuestionFromData {
  componentName: QuestionType | DecorationType;
  componentType: IQuestionComonentType;
  data: QuestionFormDataType;
}

export enum QuestionnaireSettingAction {
  basic_setting = 0,
  empty = -1,
  question = 1,
  submitBtn = 2,
  submitPageBtn = 3,
}
const defaultForm = {
  formLogicConfig: {
    itemShowLogics: [],
  },
  verificationConfig: {
    itemVerificationList: [],
    verificationLogicSwitch: "INFO",
  },
  questionData: {
    // $ 问卷唯一id
    title: "", // 标题
    introduce: "", // 介绍
    remark: "", //备注
    hideIntro: 0,
    exitPopup: "0",
    coverUrl: "", // 封面
    tips: "确定要放弃填写吗？",
    submitTitle: "提交",
    submitText: "本活动最终解释权归爱问所有",
    status: "",
    userAuth: 0,
    popupText: "确定要放弃填写吗？ ",
    leaveBtnText: "确认",
    cancelBtnText: "取消",
  }, // $ 问卷调查数据
  basicData: {
    title: "标题", // 标题
    remark: "", //备注
    coverSet: true,
    cover: "", // 封面
    coverIntroduce: "", // 介绍
    coverBtnText: "开始答题",
    shareSet: true,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: true,
    submitLimitCount: 1,
    loginSet: true,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE",
    uniqueId: "",
    totalScore: 0,
    participateUniqueCheck: false, // 是否参与唯一性校验
    participateRepeatedCheck: false, // 问卷排重
    participateRepeatedClassId: "", // 排重分类ID
    participateRepeatedClassName: "", // 排重分类名称
  },
  temBasicData: {
    title: "", // 标题
    remark: "", //备注
    coverSet: false,
    cover: "", // 封面
    coverIntroduce: "", // 介绍
    coverBtnText: "开始答题",
    shareSet: false,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: false,
    submitLimitCount: 1,
    loginSet: false,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE",
    uniqueId: "",
    totalScore: 0,
    participateUniqueCheck: false, // 是否参与唯一性校验
    participateRepeatedCheck: false, // 问卷排重
    participateRepeatedClassId: "", // 排重分类
    participateRepeatedClassName: "", // 排重分类名称
  },
  submitData: {
    countdown: 3, // $ 倒计时(单位:秒)
    jumpLinkType: 2, // $ 跳转方式 1: 社区内容 2: 外部链接
    jumpType: 2, // $ 跳转类型 0:自动跳转 1:手动跳转
    linkUrl: "index", // $ 跳转地址
    picUrl: "", // $ 图片地址
    questionnaireId: "", // $ 问卷ID
    qualifiedScore: 0, // $ 问卷ID
    tips: "正在转入活动详情页", // $ 副语
    title: "您的答卷已经提交，感谢您的参与！", // $ 标题
    answerResultRule: [
      {
        isEnable: false,
        type: "answerResultScope",
        itemShowLogics: [],
      },
      {
        isEnable: false,
        type: "answerResultSpecified",
        itemShowLogics: [],
      },
    ],
    resultList: [],
    showAnswerScore: true,
    resultSwitch: true,
  },
  activeIndex: 0, // $ 当前点击索引
  dataList: [] as Array<QuestionFromData>,
};
const jumpUrl = {
  index: {
    label: "社区首页",
    url: "index",
    value: "index",
  },
  doctors: {
    label: "名医诊室",
    url: "doctors",
    value: "doctors",
  },
  institution: {
    label: "机构列表",
    url: "institution",
    value: "institution",
  },
  tieba: {
    label: "健康圈",
    url: "tieba",
    value: "tieba",
  },
  topics: {
    label: "话题列表",
    url: "topics",
    value: "topics",
  },
  questions: {
    label: "问答列表",
    url: "tieba#qA",
    value: "questions",
  },
  article: {
    label: "文章资讯",
    url: "article",
    value: "article",
  },
  introduce: {
    label: "社区简介",
    url: "mine/about",
    value: "introduce",
  },
};

type BasicData = typeof defaultForm.basicData;
type SubmitData = typeof defaultForm.submitData;
@Module({
  name: "newQuestionnaireEditNew",
  dynamic: true,
  namespaced: true,
  store,
})
export default class QuestionnaireEdit extends VuexModule {
  public isModel = "ADD";
  public editSpecialMode = ""; // 特殊编辑模式, 强行打开单项填写
  public questionnaireType = "QUESTIONNAIRE";
  public questionnaireSource = "PATIENT";
  public questionnaireProperty = "QUESTIONNAIRE";
  // public totalScore = 0;
  public showVerifactionConfig = false;
  public jumpUrl = jumpUrl as any;
  public action = QuestionnaireSettingAction.basic_setting;
  public questionData = defaultForm.questionData; // $ 问卷调查数据
  public submitData = defaultForm.submitData;
  public basicData = defaultForm.basicData;
  public formLogicConfig = defaultForm.formLogicConfig;
  public verificationConfig = defaultForm.verificationConfig;
  public activeIndex = defaultForm.activeIndex; // $ 当前点击索引
  public dataList = defaultForm.dataList;
  public dattpaList = defaultForm.dataList;
  public activeData = { componentName: QuestionType.empty, componentType: IQuestionComonentType.Question, data: {} } as QuestionFromData;

  public stagDataList: any = [];

  public configforAllShow = false;

  get basicDataUniqueId() {
    return this.basicData.uniqueId;
  }
  get get_showVerifactionConfig() {
    return this.showVerifactionConfig;
  }
  get totalScore() {
    return this.basicData.totalScore;
  }
  get isConfigforAllShow() {
    return this.configforAllShow;
  }
  get calculatorQuestionnaireItems() {
    return this.dataList.filter((item: any) => {
      if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.singleChoicePicker) {
        return item.data.jsonConfig.openPoint == true;
      } else if (item.componentName == QuestionType.fillIn) {
        return item.data.jsonConfig.inputForm == "NUMBER";
      } else {
        return false;
      }
    });
  }
  // 设置isModel --- 查看模式;
  @Mutation
  SET_isModel(model: string) {
    this.isModel = model;
  }
  @Mutation
  SET_editSpecialMode(mode: string) {
    this.editSpecialMode = mode;
  }
  // 设置id;
  @Mutation
  SET_configforAllSetting(isSetting: boolean) {
    // console.log("SET_configforAllSetting", isSetting);
    this.configforAllShow = isSetting;
  }
  // 设置id;
  @Mutation
  SET_BASICDATA_ID(id: string) {
    this.basicData.uniqueId = id;
  }
  // $ 基本信息设置
  @Mutation
  SET_QUESTIONTYPE_PROPERTY(tp: string) {
    this.questionnaireProperty = tp;
  }
  @Mutation
  SET_QUESTIONTYPE_DATA(tp: string) {
    this.questionnaireType = tp;
  }
  @Mutation
  SET_QUESTIONNAIRESOURCE_DATA(tp: string) {
    this.questionnaireSource = tp;
  }
  @Mutation
  SET_TOTALSCORE_DATA(tp: number) {
    this.basicData.totalScore = tp;
  }

  // @Mutation
  // SET_BASICS_DATA() {
  //   this.action = QuestionnaireSettingAction.basic_setting;
  // }
  // $ 提交按钮设置
  @Mutation
  SET_SUBMIT_DATA() {
    this.action = QuestionnaireSettingAction.submitBtn;
  }
  // $ 设置当前点击索引
  @Mutation
  SET_INDEX_COMPONENTS(index: any) {
    this.action = QuestionnaireSettingAction.question;
    this.activeIndex = index;
    this.activeData = this.dataList[index];
  }
  // $ 拖动组件数据
  @Mutation
  SET_DATALIST_COMPONENTS(payload: any) {
    console.log("SET_DATALIST_COMPONENTS", payload);
    const dataList = computeSortIndex(payload);
    this.dataList = dataList;
  }
  // $ 添加组件
  @Mutation
  SET_ADD_COMPONENTS(payload: { item: IQuestionItem<any>; index: number }) {
    console.log("SET_ADD_COMPONENTS", payload);
    const item = payload.item;
    const data = {
      componentName: item.componentName,
      componentType: item.type,
      data: {
        ...item.data,
        title: item.title,
        catalogIds: [],
        whetherJoinQuestionBank: false,
      },
    };
    this.dataList.splice(this.activeIndex + 1, 0, data);
    this.dataList = computeSortIndex(this.dataList);
  }
  @Mutation
  UPDATE_COMPONENTS(payload: { item: any; index: number }) {
    console.log("UPDATE_COMPONENTS");

    this.dataList[payload.index].data = payload.item;
  }
  // $ 删除组件
  @Mutation
  SET_DELETE_COMPONENTS(payload: any) {
    console.warn("payload", payload);
    this.dataList.splice(payload, 1);
    this.dataList = computeSortIndex(this.dataList);

    console.warn("dataList", this.dataList);
    if (this.dataList.length == 0) {
      this.action = QuestionnaireSettingAction.basic_setting;
    }
  }
  // $ 问卷调查数据
  @Mutation
  SET_BASIC_DATA(payload: any) {
    this.basicData = payload;
  }
  // $ 获取问卷调查数据
  @Mutation
  SET_DATA_LIST(payload: any) {
    this.dataList = payload;
    this.dataList = computeSortIndex(this.dataList);
  }
  @Mutation
  SET_DATA_LIST_SKIPINDEX(payload: any) {
    this.dataList = computeSortIndex(payload, true);
  }
  // $ 获取提交页设置数据
  @Mutation
  SET_FORM_LOGIC_CONFIG(payload: any) {
    this.formLogicConfig = payload;
  }
  @Mutation
  SET_verificationConfig_verificationLogicSwitch(payload: any) {
    this.verificationConfig.verificationLogicSwitch = payload;
  }
  @Mutation
  SET_verificationConfig(payload: any) {
    this.verificationConfig = payload;
  }
  @Mutation
  SET_SUBMIT_LIST(payload: any) {
    this.submitData = payload;
  }
  @Mutation
  SET_BASIC_LIST(payload: any) {
    this.basicData = payload;
  }
  @Mutation
  SET_BASIC_DATA_SHARECOVER(payload: any) {
    this.basicData.shareCover = payload;
  }
  @Mutation
  SET_BASIC_DATA_UNIQUE(payload: any) {
    this.basicData.participateUniqueCheck = payload;
  }
  @Mutation
  SET_BASIC_DATA_REPEATED(payload: any) {
    this.basicData.participateRepeatedCheck = payload;
    if (!payload) this.basicData.participateRepeatedClassId = "";
  }
  @Mutation
  SET_BASIC_DATA_REPEATEDCLASSID(payload: any) {
    this.basicData.participateRepeatedClassId = payload;
  }
  @Mutation
  SET_BASIC_DATA_REPEATEDCLASSNAME(payload: any) {
    this.basicData.participateRepeatedClassName = payload;
  }
  @Mutation
  SET_showVerificationConfig(payload: any) {
    // console.log("SET_showVerificationConfig", payload);
    this.showVerifactionConfig = payload;
  }

  // $ 重置数据
  @Mutation
  SET_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionnaireProperty = "ACTIVITY_INTERACT";
    this.configforAllShow = false;
    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.formLogicConfig = JSON.parse(JSON.stringify(defaultForm.formLogicConfig));
    this.verificationConfig = JSON.parse(JSON.stringify(defaultForm.verificationConfig));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.temBasicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
    this.dataList = computeSortIndex(this.dataList);
  }
  @Mutation
  SET_TEMP_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.configforAllShow = false;

    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.formLogicConfig = JSON.parse(JSON.stringify(defaultForm.formLogicConfig));
    this.verificationConfig = JSON.parse(JSON.stringify(defaultForm.verificationConfig));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.temBasicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
    this.dataList = computeSortIndex(this.dataList);
  }
  // $
  @Mutation
  SET_NUMBER_INDEX(payload: any) {
    this.dataList[payload.index].data.number = payload.number;
  }
  // * 设置从题库中选择的数据
  @Mutation
  SET_STAG_DATA_LIST(payload: any) {
    this.stagDataList = payload;
  }
  // * 重置从题库中选择的数据
  @Mutation
  RESET_STAG_DATA_LIST() {
    this.stagDataList = [];
  }
  // // $ 隐藏问卷介绍
  // @Mutation
  // SET_HIDE_INTRO(payload: any) {
  //   this.questionData.hideIntro = payload;
  // }

  // @Action({commit: 'updatePosts'})
  // async function fetchPosts() {
  //     return await get('https://jsonplaceholder.typicode.com/posts')
  // }

  // $ 获取问卷详情
  @Action
  public async GET_QUESTIONNAIRE_DETAIL(id: string) {
    const res = await service.questionnaireGetDetailById({ id });
    const data: any = res.data;

    // if (Object.keys(data).length > 1) {
    const result = transformToUIData(data);
    this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);
    this.SET_verificationConfig(result.verificationConfig);

    this.SET_BASIC_DATA(result.basicData);
    this.SET_DATA_LIST(result.datalist);
    this.SET_SUBMIT_LIST(result.submitData);
    // }
    return data;
  }
  @Action({ rawError: true })
  public async INTERT_ANSWER_DETAIL(itemList: any) {
    const dataList: any = JSON.parse(JSON.stringify(this.dataList));
    const newDataList: any = [];
    itemList.forEach((item: any) => {
      const oindex = dataList.findIndex((oitem: any) => {
        return oitem.data.id == item.id;
      });
      if ([1, 2, 9, 10, 3, 12, 11, 23, 21, 22, 13, 14, 6, 25, 26, 27, 28, 29, 30].includes(item.type)) {
        // if (item.answer) {
        //   item.answer = JSON.parse(item.answer);
        // }
        // 单选多选 回填答案

        // console.log("INTERT_ANSWER_DETAILoindex", oindex);

        if (oindex >= 0) {
          dataList[oindex].data.answered = item.answer;
          dataList[oindex].data.answerScore = item.answerScore;
          dataList[oindex].data.rightAnswer = item.rightAnswer;

          if (item.type == 1) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer[0] ? item.answer[0].id : "";
              const answerOptionIndex = dataList[oindex].data.optionsList.findIndex((op: any) => {
                return op.id == dataList[oindex].data.answer;
              });
              if (answerOptionIndex >= 0) {
                const content1 = dataList[oindex].data.jsonConfig.otherInputForm !== "NUMBER" ? (item.answer[0] ? item.answer[0].content : "") : item.answer[0] ? item.answer[0].content : undefined;
                dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer = content1;
                // console.log("dataList", dataList[oindex].data);
                const content2 = dataList[oindex].data.jsonConfig.secondOtherInputForm !== "NUMBER" ? (item.answer[0] ? item.answer[0].content2 : "") : item.answer[0] ? item.answer[0].content2 : undefined;

                dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer2 = content2;
              }
            } else {
              dataList[oindex].data.answer = "";
            }
          }
          if (item.type == 2 && item.answer) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.map((as: any) => {
                return as.id;
              });
              if (item.answer.length > 0) {
                item.answer.forEach((oas: any) => {
                  const answerOptionIndex = dataList[oindex].data.optionsList.findIndex((op: any) => {
                    return op.id == oas.id;
                  });
                  if (answerOptionIndex >= 0) {
                    // console.log("dataList", dataList[oindex].data, oas);
                    const content1 = dataList[oindex].data.jsonConfig.otherInputForm !== "NUMBER" ? (oas.content ? oas.content : "") : oas.content ? oas.content : undefined;
                    dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer = content1;
                    const content2 = dataList[oindex].data.jsonConfig.secondOtherInputForm !== "NUMBER" ? (oas.content2 ? oas.content2 : "") : oas.content2 ? oas.content2 : undefined;
                    dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer2 = content2;
                  }
                });
              }
            } else {
              dataList[oindex].data.answer = [];
            }
          }
          if (item.type == 9) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.id;
            }
          }
          if (item.type == 10) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.map((as: any) => {
                return as.id;
              });
            }
          }
          if (item.type == 3) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.input;
            }
          }
          if (item.type == 12) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 11) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
              if (dataList[oindex].data.jsonConfig && dataList[oindex].data.jsonConfig.inputList) {
                dataList[oindex].data.jsonConfig.inputList.forEach((input: any, index: any) => {
                  if (item.answer[index]) {
                    input.answer = item.answer[index].answer;
                  }
                });
              }
            }
          }
          if (item.type == 23) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 21) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 22) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 13) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.dateTime;
            }
          }
          if (item.type == 14) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 6) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.urls.split(",");
            }
          }
          if (item.type == 25) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.input;
            }
          }
          if (item.type == 26) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 27) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer[0].id;
            }
          }
          if (item.type == 28) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.dateTime;
            }
          }
          if (item.type == 29) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 30) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }

          // dataList[oindex].data.optionsList.forEach((op: any) => {
          //   op.answered = item.answer.some((as: any) => {
          //     return op.id == as.id;
          //   });
          // });
        }
      }
      newDataList.push(dataList[oindex]);
    });

    // console.log("INTERT_ANSWER_DETAIL", dataList);
    this.SET_DATA_LIST_SKIPINDEX(newDataList);

    // return data;
  }

  // $ 保存暂存数据
  @Action
  async SAVE_QUESTIONNAIRE_DRAFT() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const questionnaireProperty = this.questionnaireProperty;
    const formLogicConfig = this.formLogicConfig;
    const verificationConfig = this.verificationConfig;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, questionnaireProperty, verificationConfig);

    return saveQuestionnaireDraft(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
  // $ 保存问卷
  @Action
  async SAVE_QUESTIONNAIRE(id: string) {
    console.log("SAVE_QUESTIONNAIRE", id);

    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;

    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    params.status = 1;
    // console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service
      .saveQuestionnaire(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error: any) => {
        return error;
      });
  }
  // $ 保存问卷
  @Action
  async SAVE_TEMPLATE(id: string) {
    console.log("SAVE_TEMPLATE", status);

    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    return await service
      .questionnaireTemplateSave(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error: any) => {
        return error;
      });
  }
  /////////////////
  // 2024年6月4日12:06:29 活动内保存模板库 且换名字
  // @Action
  // async SAVE_TEMPLATE_WITHTITLE(title: string) {
  //   // const basicData = this.basicData;
  //   // const questionnaireType = this.questionnaireType;
  //   // const questionnaireSource = this.questionnaireSource;
  //   // const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
  //   // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
  //   // const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig);
  //   params.id = "";
  //   params.title = title;
  //   params.status = 1;

  //   // console.log("SAVE_TEMPLATEthis.dataListparams", params);
  //   return await service
  //     .questionnaireTemplateSave(params as any)
  //     .then((data: any) => {
  //       return data;
  //     })
  //     .catch((error: any) => {
  //       return error;
  //     });
  // }
  ///////////////////
  //2024年6月4日12:06:39 活动内保存下线模板
  @Action
  async SAVE_ACTIVITY_TEMPLATE(id: string) {
    console.log("SAVE_TEMPLATE", id);

    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    params.status = 0;
    // console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service
      .questionnaireTemplateSave(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error: any) => {
        return error;
      });
  }
  // $ 新增/保存问卷模板
  @Action
  async UPDATE_TEMPLATE(id: string | number) {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service
      .questionnaireTemplateSave(params)
      .then((res: any) => {
        return res;
      })
      .catch((error: any) => {
        return error;
      });
  }
  // $ 获取暂存数据
  @Action
  async GET_TEMPLATE(id: string) {
    return service
      .questionnaireTemplateGetDetail({ id })
      .then((res: any) => {
        console.log("formtemplateGetDetail", res);
        const data: any = res.data;
        // if (Object.keys(data).length > 1) {
        const result = transformToUIData(data);
        this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);
        this.SET_verificationConfig(result.verificationConfig);

        this.SET_BASIC_DATA(result.basicData);
        this.SET_DATA_LIST(result.datalist);
        this.SET_SUBMIT_LIST(result.submitData);
        // }
        return data;
      })
      .catch((error: any) => {
        return error;
      });
  }
  // $ 获取暂存数据
  @Action
  async GET_QUESTIONNAIREDraftByCommtyId() {
    // const questionData = this.questionData;
    return getQuestionnaireDraftByCommtyId({ communityId: store.state.comtyId, questionnaireType: this.questionnaireType, questionnaireSource: this.questionnaireSource })
      .then((res: any) => {
        console.warn("getQuestionnaireDraftByCommtyId", res);
        const data: any = res.data;
        if (Object.keys(data).length > 1) {
          const result = transformToUIData(data);
          this.SET_BASIC_DATA(result.basicData);
          this.SET_DATA_LIST(result.datalist);
          this.SET_SUBMIT_LIST(result.submitData);
        }
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
  // $ 设置问卷模板数据（查看、编辑）
  // @Action
  // async SET_TEMPLATE(id: string) {
  //   return service
  //     .questionnaireTemplateGetDetail({ id })
  //     .then((res: any) => {
  //       console.log("formtemplateGetDetail", res);
  //       const data: any = res.data;
  //       // if (Object.keys(data).length > 1) {
  //       const result = transformToUIData(data);
  //       this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);

  //       // TODO: SET_BASIC_DATA SET_SUBMIT_LIST
  //       this.SET_BASIC_DATA(result.basicData);
  //       this.SET_DATA_LIST(result.datalist);
  //       this.SET_SUBMIT_LIST(result.submitData);
  //       // }
  //       return data;
  //     })
  //     .catch((error: any) => {
  //       return error;
  //     });
  // }
  @Action
  async CHECK_DATA() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = this.formLogicConfig;
    const verificationConfig = this.verificationConfig;
    // console.log("asdfasdf");
    try {
      const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
      return await checkItemExist(params as any)
        .then((data: any) => {
          return data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      console.log("asdfasdf3", error);
    }
  }
  // console.log("asdfasdf2");
}

// !初始化问卷答题数据
export function transformToUIData(data: any) {
  console.log("transformToUIData", data);

  try {
    const formLogicConfig = data.formLogicConfig;
    const verificationConfig = data.verificationConfig;
    const basicData = {
      uniqueId: data.id || undefined,

      title: data.title, // 标题
      remark: data.remark, //备注
      coverSet: data.coverSet || false,
      cover: data.cover || "", // 封面
      coverIntroduce: data.coverIntroduce || "", // 介绍
      coverBtnText: data.coverBtnText || "",
      shareSet: data.shareSet || false,
      shareCover: data.shareCover || "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
      shareTitle: data.shareTitle || "",
      shareIntroduce: data.shareIntroduce || "",
      submitLimit: data.submitLimit || false,
      submitLimitCount: data.submitLimitCount || 1,
      loginSet: data.loginSet || false,
      joinDoctorLimit: data.joinDoctorLimit || "COMMUNITYDOCTOR",
      joinDoctorType: data.joinDoctorType || [],
      exitPopup: data.exitPopup + "",
      popupText: data.popupText,
      pageSet: data.pageSet,
      totalScore: data.totalScore,
      participateUniqueCheck: data.participateUniqueCheck,
      participateRepeatedCheck: data.participateRepeatedCheck,
      participateRepeatedClassId: data.participateRepeatedClassId,
      participateRepeatedClassName: data.participateRepeatedClassName,
    };

    const serviceSubmitData = data.submitItemList ? data.submitItemList[0] : {};
    const submitData = {
      countdown: serviceSubmitData.countdown, // $ 倒计时(单位:秒)
      jumpLinkType: serviceSubmitData.jumpLinkType || 1, // $ 跳转方式 1: 社区内容 2: 外部链接
      jumpType: serviceSubmitData.jumpType || 0, // $ 跳转类型 0:自动跳转 1:手动跳转
      linkUrl: serviceSubmitData.linkUrl, // $ 跳转地址
      picUrl: serviceSubmitData.picUrl, // $ 图片地址
      questionnaireId: serviceSubmitData.questionnaireId, // $ 问卷ID
      tips: serviceSubmitData.tips, // $ 副语
      title: serviceSubmitData.title, // $ 标题    qualifiedScore: 0, // $ 问卷ID
      qualifiedScore: data.qualifiedScore || 0, // $ 标题
      resultList: data.resultList,
      showAnswerScore: data.showAnswerScore,
      resultSwitch: data.resultSwitch,
      answerResultRule: [],
    };
    const answerResultRule: any = [];

    if (data.answerResultRule) {
      if (data.answerResultRule.answerResultScope.priorityIndex == 0) {
        answerResultRule.push({
          ...data.answerResultRule.answerResultScope,
          type: "answerResultScope",
        });
        answerResultRule.push({
          ...data.answerResultRule.answerResultSpecified,
          type: "answerResultSpecified",
        });
      } else {
        answerResultRule.push({
          ...data.answerResultRule.answerResultSpecified,
          type: "answerResultSpecified",
        });
        answerResultRule.push({
          ...data.answerResultRule.answerResultScope,
          type: "answerResultScope",
        });
      }
    }
    submitData.answerResultRule = answerResultRule;
    const datalist = [] as Array<any>;
    walkArray(data.itemList, (item) => {
      const question = {
        componentName: item.type as string,
        componentStyle: item.style as string,
        data: {
          id: item.id,
          required: item.required,
          number: item.number,
          type: item.type,
          style: item.style,
          whetherJoinQuestionBank: item.joinBank || false,
          fromQuestionBank: !!item.fromQuestionBank,
          catalogIds: item.catalogIds || [],
        },
      };
      if (item.type == QuestionType.singleChoice || item.type == QuestionType.multipleChoice || item.type == QuestionType.cascade || item.type == QuestionType.singleChoicePicker || item.type == QuestionType.multipleChoicePicker || item.type == QuestionType.sex || item.type == QuestionType.diagnosis) {
        const data = question.data as IMultipleChoiceData | ISingleChoiceData | ISingleChoicePickerData | IMultipleChoicePickerData;
        item.optionsList.forEach((op: any) => {
          if (op.jsonConfig) {
            op.jsonConfig = JSON.parse(op.jsonConfig);
          } else {
            op.jsonConfig = {
              exclusive: false,
            };
          }
        });
        data.optionsList = item.optionsList;
        data.jsonConfig = JSON.parse(item.jsonConfig);

        data.title = item.question;
        data.optionContentType = item.optionContentType;
        data.itemScore = item.itemScore || 0;
        data.scoreRule = item.scoreRule;
        //       optionContentType: string; // 是否必填: number;
        // itemScore?: number;
      }

      if (item.type == DecorationType.cutOffLine) {
        const data = question.data as ICutOffLineData;
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.jsonConfig = jsonConfig;
      }
      if (item.type == QuestionType.department || item.type == QuestionType.fillInMulti || item.type == QuestionType.fillInRange || item.type == QuestionType.dateTime || item.type == QuestionType.addressInput || item.type == QuestionType.diagnosisTime || item.type == QuestionType.onlineBooking) {
        const data = question.data as IDepartment | IFillInMultiData | IFillInRangeData | IDateTimeData | IAddressInputData;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }

      if (item.type == DecorationType.picture) {
        const data = question.data as IImageData;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.url = jsonConfig.url;
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.url = "";
        }
      }
      if (item.type == DecorationType.text) {
        const data = question.data as ITextTData;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.text = jsonConfig.text;
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.text = "";
        }
      }
      if (item.type == QuestionType.uploadAddon) {
        const data = question.data as IAddonData;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
        data.uploadLimitCount = item.uploadLimitCount;
      }

      if (item.type == QuestionType.phoneNumber) {
        const data = question.data as IPhoneNumberData;
        data.title = item.question;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.phoneNumber = jsonConfig.default; //填空题的默认文本
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.phoneNumber = "";
        }
      }
      if (item.type == QuestionType.fillIn || item.type == QuestionType.patientName || item.type == QuestionType.age) {
        const data = question.data as IFillInData;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
        data.itemScore = item.itemScore;
        data.rightText = item.rightText;
        data.scoreRule = item.scoreRule;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.content = jsonConfig.default; //填空题的默认文本
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.content = "";
        }
      }
      if (item.type == QuestionType.sort) {
        const data = question.data as ISortData;
        data.title = item.question;
        data.optionsList = item.optionsList;
        data.optionContentType = item.optionContentType;

        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == QuestionType.proportion) {
        const data = question.data as IProportionData;
        data.title = item.question;
        data.optionsList = item.optionsList;
        data.optionContentType = item.optionContentType;

        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == QuestionType.fillInTable) {
        const data = question.data as IFillInTableData;
        data.title = item.question;
        data.optionsList = item.optionsList;

        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == DecorationType.calculator) {
        const data = question.data as ICalculatorData;
        data.title = item.question;

        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      // (question.data as IQuestion).whetherJoinQuestionBank = false;
      datalist.push(question);
    });
    return { basicData, datalist, submitData, formLogicConfig, verificationConfig };
  } catch (error) {
    console.log("transformToUIDataerror", error);
    return {};
  }
}
function transformToServerData(rootState: any, questionnaireType: string, questionnaireSource: string, basicData: BasicData, dataList: Array<QuestionFromData>, submitData: SubmitData, formLogicConfig: any, questionnaireProperty: string, verificationConfig: any) {
  const itemList = transformDataListToServerData(dataList);
  const params: any = {
    formLogicConfig,
    verificationConfig,
    questionnaireType,
    questionnaireSource,
    ...basicData,
    submitItemList: [submitData],
    qualifiedScore: submitData.qualifiedScore || 0,
    itemList: itemList,
    questionnaireProperty: questionnaireProperty,
    // formProperty: "ACTIVITY_INTERACT",
    resultList: submitData.resultList,
    showAnswerScore: submitData.showAnswerScore,
    resultSwitch: submitData.resultSwitch,
  };
  //转换提交步骤的数据
  const answerResultRule: any = {};
  if (submitData.answerResultRule && submitData.answerResultRule.length) {
    submitData.answerResultRule.forEach((rule, index) => {
      answerResultRule[rule.type] = {
        ...rule,
        priorityIndex: index,
      };
    });
  }
  params.answerResultRule = answerResultRule;
  if (questionnaireSource == "PATIENT") {
    delete params.joinDoctorLimit;
    delete params.joinDoctorType;
  }
  // console.log("transformToServerData", params);
  return params;
}
export function transformDataListToServerData(datalist: Array<QuestionFromData>) {
  const data = datalist.map((item) => {
    const formData = item.data;
    // console.warn("formData1", formData);
    const question: any = {
      required: formData.required,
      type: item.componentName,
      style: item.componentType,
      number: formData.number,
      catalogIds: formData.catalogIds || [],
      joinBank: !!formData.whetherJoinQuestionBank,
      fromQuestionBank: !!formData.fromQuestionBank,
    };
    if (formData.id) question.id = formData.id;
    if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.multipleChoice || item.componentName == QuestionType.cascade || item.componentName == QuestionType.singleChoicePicker || item.componentName == QuestionType.multipleChoicePicker || item.componentName == QuestionType.sex || item.componentName == QuestionType.diagnosis) {
      question.optionsList = JSON.parse(JSON.stringify((formData as ISingleChoiceData).optionsList));
      question.jsonConfig = JSON.stringify((formData as ISingleChoiceData).jsonConfig);
      question.question = (formData as ISingleChoiceData).title;
      question.itemScore = (formData as ISingleChoiceData).itemScore;
      question.scoreRule = (formData as ISingleChoiceData).scoreRule;
      question.optionContentType = (formData as ISingleChoiceData).optionContentType;
      // console.log("transformDataListToServerData", new Date(), question.optionsList);
      question.optionsList.forEach((op: any) => {
        op.jsonConfig = op.jsonConfig ? JSON.stringify(op.jsonConfig) : JSON.stringify({});
      });
      if (item.componentName === QuestionType.diagnosis) {
        // 诊断题 数据处理
        question.jsonConfig = JSON.parse(question.jsonConfig);
        if ((formData as ISingleChoiceData).optionContentType === "FILLIN") {
          // 填写类型
          question.optionsList = [];
          delete question.jsonConfig.otherInputNumberMax;
          delete question.jsonConfig.otherInputNumberMin;
          delete question.jsonConfig.selectRangeMax;
          delete question.jsonConfig.selectRangeMin;
        } else {
          delete question.jsonConfig.fillInMax;
          delete question.jsonConfig.fillInMin;
        }
        question.jsonConfig = JSON.stringify(question.jsonConfig);
      }
    }

    if (item.componentName == QuestionType.sort) {
      question.optionsList = (formData as ISortData).optionsList;
      question.jsonConfig = JSON.stringify((formData as ISortData).jsonConfig);

      question.question = (formData as ISortData).title;
      question.itemScore = (formData as ISortData).itemScore;
      question.optionContentType = (formData as ISortData).optionContentType;
    }

    if (item.componentName == QuestionType.proportion) {
      question.optionsList = (formData as IProportionData).optionsList;
      question.jsonConfig = JSON.stringify((formData as IProportionData).jsonConfig);

      question.question = (formData as IProportionData).title;
      question.itemScore = (formData as IProportionData).itemScore;
      question.optionContentType = (formData as IProportionData).optionContentType;
    }

    if (item.componentName == QuestionType.fillIn || item.componentName === QuestionType.patientName || item.componentName == QuestionType.age) {
      const jsonConfig = { ...(formData as IFillInData).jsonConfig, default: (formData as IFillInData).content };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = (formData as IFillInData).title;
      question.itemScore = (formData as IFillInData).itemScore;
      question.rightText = (formData as IFillInData).rightText;
      question.scoreRule = (formData as IFillInData).scoreRule;
    }

    if (item.componentName == DecorationType.picture) {
      const jsonConfig = { url: (formData as IImageData).url };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == DecorationType.text) {
      const jsonConfig = { text: (formData as ITextTData).text };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == QuestionType.phoneNumber) {
      const jsonConfig = { default: (formData as IPhoneNumberData).phoneNumber };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = (formData as IPhoneNumberData).title;
    }
    if (item.componentName == QuestionType.uploadAddon) {
      const data = formData as IAddonData;
      question.jsonConfig = JSON.stringify(data.jsonConfig);
      question.question = data.title;
      question.uploadLimitCount = data.uploadLimitCount;
    }
    if (item.componentName == DecorationType.cutOffLine) {
      question.jsonConfig = JSON.stringify((formData as ICutOffLineData).jsonConfig);
      // question.question = (formData as ICutOffLineData).title;
    }
    if (item.componentName == QuestionType.department || item.componentName == DecorationType.calculator || item.componentName == QuestionType.fillInMulti || item.componentName == QuestionType.fillInRange || item.componentName == QuestionType.dateTime || item.componentName == QuestionType.addressInput || item.componentName == QuestionType.diagnosisTime) {
      question.question = (formData as any).title;
      question.jsonConfig = JSON.stringify((formData as any).jsonConfig);
    }
    if (item.componentName == QuestionType.fillInTable) {
      question.optionsList = (formData as IFillInTableData).optionsList;
      question.jsonConfig = JSON.stringify((formData as IFillInTableData).jsonConfig);
      question.question = (formData as IFillInTableData).title;
      question.itemScore = (formData as IFillInTableData).itemScore;
    }
    if (item.componentName == QuestionType.onlineBooking) {
      question.question = (formData as any).title;
      question.jsonConfig = JSON.stringify((formData as any).jsonConfig);
      if (question.jsonConfig.appointmentMethod === "APPOINTMENT_METHOD_DAY") {
        question.jsonConfig.dailyStartAndEndTime = [];
        question.jsonConfig.hourlyDuration = undefined;
        question.jsonConfig.intervalTime = undefined;
      }
      if (question.jsonConfig.appointmentMethod === "UNLIMITED") question.jsonConfig.appointmentDateRange = [];
    }

    return question;
  });
  return data;
}
function computeSortIndex(dataList: any, TrueSort = false) {
  let sort = 0;
  dataList.forEach((item: any) => {
    if (item.componentName == DecorationType.calculator || item.componentName == DecorationType.picture || item.componentName == DecorationType.text || item.componentName == DecorationType.cutOffLine || item.componentName == DecorationType.pageGap || (TrueSort && !item.data.jsonConfig.showIndex)) {
      //无需处理
      item.data.number = "";
    } else {
      item.data.number = sort;
      sort++;
    }
  });
  console.log("computeSortIndex", dataList);
  return dataList;
}
export const QuestionnaireEditModule = getModule(QuestionnaireEdit);
